<!-- SkyPlus Profile Page -->
<div class="page-wrapper">
  
  <!-- Top Navigation Bar -->
  <sp-header></sp-header>
  
  <!-- Profile Content -->
  <div class="profile-page">
    
    <!-- Page Header -->
    <div class="profile-header">
      <button class="back-btn" (click)="goBack()">
        <span class="material-icons">arrow_back</span>
      </button>
      <h1>My Profile</h1>
    </div>
    
    <!-- Loading State -->
    <div class="loading-overlay" *ngIf="isLoading">
      <div class="spinner"></div>
      <p>Loading profile...</p>
    </div>
    
    <!-- Profile Content -->
    <div class="profile-content" *ngIf="!isLoading">
      
      <!-- General Section -->
      <div class="profile-section" [class.profile-section--expanded]="generalExpanded">
        <div class="profile-section__header" (click)="toggleGeneralSection()">
          <div class="profile-section__title">
            <span class="material-icons profile-section__chevron">
              {{ generalExpanded ? 'expand_more' : 'chevron_right' }}
            </span>
            <span>General</span>
          </div>
          <div class="profile-section__actions" *ngIf="generalExpanded">
            <ng-container *ngIf="!editingGeneral">
              <button class="section-btn" (click)="editGeneral(); $event.stopPropagation()">
                Edit
              </button>
            </ng-container>
            <ng-container *ngIf="editingGeneral">
              <button class="section-btn section-btn--outline" 
                      (click)="cancelGeneralEdit(); $event.stopPropagation()"
                      [disabled]="isSaving">
                Cancel
              </button>
              <button class="section-btn section-btn--primary" 
                      (click)="saveGeneral(); $event.stopPropagation()"
                      [disabled]="isSaving">
                {{ isSaving ? 'Saving...' : 'Save' }}
              </button>
            </ng-container>
          </div>
        </div>
        
        <div class="profile-section__content" *ngIf="generalExpanded">
          <!-- First Name -->
          <div class="profile-field">
            <label class="profile-field__label">First name</label>
            <div class="profile-field__value" *ngIf="!editingGeneral">
              {{ profile.firstName || '-' }}
            </div>
            <input type="text" 
                   class="profile-field__input" 
                   [(ngModel)]="profile.firstName"
                   *ngIf="editingGeneral"
                   placeholder="Enter first name">
          </div>
          
          <!-- Last Name -->
          <div class="profile-field">
            <label class="profile-field__label">Last name</label>
            <div class="profile-field__value" *ngIf="!editingGeneral">
              {{ profile.lastName || '-' }}
            </div>
            <input type="text" 
                   class="profile-field__input" 
                   [(ngModel)]="profile.lastName"
                   *ngIf="editingGeneral"
                   placeholder="Enter last name">
          </div>
          
          <!-- Job Title -->
          <div class="profile-field">
            <label class="profile-field__label">Job title</label>
            <div class="profile-field__value" *ngIf="!editingGeneral">
              {{ profile.jobTitle || '-' }}
            </div>
            <input type="text" 
                   class="profile-field__input" 
                   [(ngModel)]="profile.jobTitle"
                   *ngIf="editingGeneral"
                   placeholder="Enter job title">
          </div>
          
          <!-- Location -->
          <div class="profile-field">
            <label class="profile-field__label">Location</label>
            <div class="profile-field__value" *ngIf="!editingGeneral">
              {{ profile.location || '-' }}
            </div>
            <input type="text" 
                   class="profile-field__input" 
                   [(ngModel)]="profile.location"
                   *ngIf="editingGeneral"
                   placeholder="Enter location">
          </div>
          
          <!-- Telephone -->
          <div class="profile-field">
            <label class="profile-field__label">Telephone</label>
            <div class="profile-field__value" *ngIf="!editingGeneral">
              {{ profile.telephone || '-' }}
            </div>
            <input type="tel" 
                   class="profile-field__input" 
                   [(ngModel)]="profile.telephone"
                   *ngIf="editingGeneral"
                   placeholder="Enter telephone">
          </div>
          
          <!-- Mobile -->
          <div class="profile-field">
            <label class="profile-field__label">Mobile</label>
            <div class="profile-field__value" *ngIf="!editingGeneral">
              {{ profile.mobile || '-' }}
            </div>
            <input type="tel" 
                   class="profile-field__input" 
                   [(ngModel)]="profile.mobile"
                   *ngIf="editingGeneral"
                   placeholder="Enter mobile">
          </div>
          
          <!-- Email (Read-only) -->
          <div class="profile-field">
            <label class="profile-field__label">Email</label>
            <div class="profile-field__value">
              {{ profile.email || '-' }}
            </div>
          </div>
        </div>
      </div>
      
      <!-- Company Details Section -->
      <div class="profile-section" [class.profile-section--expanded]="companyExpanded">
        <div class="profile-section__header" (click)="toggleCompanySection()">
          <div class="profile-section__title">
            <span class="material-icons profile-section__chevron">
              {{ companyExpanded ? 'expand_more' : 'chevron_right' }}
            </span>
            <span>Company details</span>
          </div>
          <div class="profile-section__actions" *ngIf="companyExpanded">
            <ng-container *ngIf="!editingCompany">
              <button class="section-btn" (click)="editCompany(); $event.stopPropagation()">
                Edit
              </button>
            </ng-container>
            <ng-container *ngIf="editingCompany">
              <button class="section-btn section-btn--outline" 
                      (click)="cancelCompanyEdit(); $event.stopPropagation()"
                      [disabled]="isSaving">
                Cancel
              </button>
              <button class="section-btn section-btn--primary" 
                      (click)="saveCompany(); $event.stopPropagation()"
                      [disabled]="isSaving">
                {{ isSaving ? 'Saving...' : 'Save' }}
              </button>
            </ng-container>
          </div>
        </div>
        
        <div class="profile-section__content" *ngIf="companyExpanded">
          <!-- Company Name -->
          <div class="profile-field">
            <label class="profile-field__label">Company name</label>
            <div class="profile-field__value" *ngIf="!editingCompany">
              {{ profile.company || '-' }}
            </div>
            <input type="text" 
                   class="profile-field__input" 
                   [(ngModel)]="profile.company"
                   *ngIf="editingCompany"
                   placeholder="Enter company name">
          </div>
          
          <!-- Address Line 1 -->
          <div class="profile-field">
            <label class="profile-field__label">Address line 1</label>
            <div class="profile-field__value" *ngIf="!editingCompany">
              {{ profile.companyAddress1 || '-' }}
            </div>
            <input type="text" 
                   class="profile-field__input" 
                   [(ngModel)]="profile.companyAddress1"
                   *ngIf="editingCompany"
                   placeholder="Enter address">
          </div>
          
          <!-- Address Line 2 -->
          <div class="profile-field">
            <label class="profile-field__label">Address line 2</label>
            <div class="profile-field__value" *ngIf="!editingCompany">
              {{ profile.companyAddress2 || '-' }}
            </div>
            <input type="text" 
                   class="profile-field__input" 
                   [(ngModel)]="profile.companyAddress2"
                   *ngIf="editingCompany"
                   placeholder="Enter address">
          </div>
          
          <!-- Address Line 3 -->
          <div class="profile-field">
            <label class="profile-field__label">Address line 3</label>
            <div class="profile-field__value" *ngIf="!editingCompany">
              {{ profile.companyAddress3 || '-' }}
            </div>
            <input type="text" 
                   class="profile-field__input" 
                   [(ngModel)]="profile.companyAddress3"
                   *ngIf="editingCompany"
                   placeholder="Enter address">
          </div>
          
          <!-- Postcode -->
          <div class="profile-field">
            <label class="profile-field__label">Postcode</label>
            <div class="profile-field__value" *ngIf="!editingCompany">
              {{ profile.companyPostcode || '-' }}
            </div>
            <input type="text" 
                   class="profile-field__input" 
                   [(ngModel)]="profile.companyPostcode"
                   *ngIf="editingCompany"
                   placeholder="Enter postcode">
          </div>
          
          <!-- Company Telephone -->
          <div class="profile-field">
            <label class="profile-field__label">Telephone</label>
            <div class="profile-field__value" *ngIf="!editingCompany">
              {{ profile.companyTelephone || '-' }}
            </div>
            <input type="tel" 
                   class="profile-field__input" 
                   [(ngModel)]="profile.companyTelephone"
                   *ngIf="editingCompany"
                   placeholder="Enter telephone">
          </div>
          
          <!-- Company Fax -->
          <div class="profile-field">
            <label class="profile-field__label">Fax</label>
            <div class="profile-field__value" *ngIf="!editingCompany">
              {{ profile.companyFax || '-' }}
            </div>
            <input type="tel" 
                   class="profile-field__input" 
                   [(ngModel)]="profile.companyFax"
                   *ngIf="editingCompany"
                   placeholder="Enter fax">
          </div>
          
          <!-- Company Email -->
          <div class="profile-field">
            <label class="profile-field__label">Email</label>
            <div class="profile-field__value" *ngIf="!editingCompany">
              {{ profile.companyEmail || '-' }}
            </div>
            <input type="email" 
                   class="profile-field__input" 
                   [(ngModel)]="profile.companyEmail"
                   *ngIf="editingCompany"
                   placeholder="Enter email">
          </div>
        </div>
      </div>
      
    </div>
  </div>
</div>
